/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CardCheckoutPaymentMethodDto
 */
export interface CardCheckoutPaymentMethodDto {
    /**
     * 
     * @type {string}
     * @memberof CardCheckoutPaymentMethodDto
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof CardCheckoutPaymentMethodDto
     */
    encryptedCardNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CardCheckoutPaymentMethodDto
     */
    encryptedExpiryMonth?: string;
    /**
     * 
     * @type {string}
     * @memberof CardCheckoutPaymentMethodDto
     */
    encryptedExpiryYear?: string;
    /**
     * 
     * @type {string}
     * @memberof CardCheckoutPaymentMethodDto
     */
    encryptedSecurityCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CardCheckoutPaymentMethodDto
     */
    holderName?: string;
    /**
     * 
     * @type {string}
     * @memberof CardCheckoutPaymentMethodDto
     */
    applePayToken?: string;
}

/**
 * Check if a given object implements the CardCheckoutPaymentMethodDto interface.
 */
export function instanceOfCardCheckoutPaymentMethodDto(value: object): value is CardCheckoutPaymentMethodDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function CardCheckoutPaymentMethodDtoFromJSON(json: any): CardCheckoutPaymentMethodDto {
    return CardCheckoutPaymentMethodDtoFromJSONTyped(json, false);
}

export function CardCheckoutPaymentMethodDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardCheckoutPaymentMethodDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'encryptedCardNumber': json['encryptedCardNumber'] == null ? undefined : json['encryptedCardNumber'],
        'encryptedExpiryMonth': json['encryptedExpiryMonth'] == null ? undefined : json['encryptedExpiryMonth'],
        'encryptedExpiryYear': json['encryptedExpiryYear'] == null ? undefined : json['encryptedExpiryYear'],
        'encryptedSecurityCode': json['encryptedSecurityCode'] == null ? undefined : json['encryptedSecurityCode'],
        'holderName': json['holderName'] == null ? undefined : json['holderName'],
        'applePayToken': json['applePayToken'] == null ? undefined : json['applePayToken'],
    };
}

export function CardCheckoutPaymentMethodDtoToJSON(json: any): CardCheckoutPaymentMethodDto {
    return CardCheckoutPaymentMethodDtoToJSONTyped(json, false);
}

export function CardCheckoutPaymentMethodDtoToJSONTyped(value?: CardCheckoutPaymentMethodDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'encryptedCardNumber': value['encryptedCardNumber'],
        'encryptedExpiryMonth': value['encryptedExpiryMonth'],
        'encryptedExpiryYear': value['encryptedExpiryYear'],
        'encryptedSecurityCode': value['encryptedSecurityCode'],
        'holderName': value['holderName'],
        'applePayToken': value['applePayToken'],
    };
}

